module.exports = __webpack_public_path__ + "./static/img/media_big.831128baf5113bdff5bb7df49a617490.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/media_big.png
// module id = ./client/src/assets/fontawesome/media_big.png
// module chunks = 0